/* eslint-disable no-unused-vars */
export enum DisclosureStatusEnum {
    None = 0,
    Draft = 1,
    ThirtyDayReview = 2,
    ReviewComplete = 3,
    SubmittedToPublisher = 4,
    Published = 5,
    NotPublished = 6,
    Withdrawn = 7,
}
